import { readJson, type PublicUser } from "../types"
const BASE_URL = "/api/v1"

export async function fetchUsers() {
  const response = await fetch(`${BASE_URL}/users`, {
    credentials: "include",
  })
  if (!response.ok) throw new Error("Failed to fetch users")
  const { data } = await readJson<PublicUser[]>(response)
  return data
}

export async function fetchUser(userId: string | number) {
  const response = await fetch(`${BASE_URL}/users/${userId}`, {
    credentials: "include",
  })
  if (!response.ok) throw new Error("User not found")
  const { data } = await readJson<PublicUser>(response)
  return data
}
